import React from "react";
import { Icon } from "semantic-ui-react";
import "../Css/AvatarEditor.css";

var previewResult;

const openEditor = (img) => {
  var canvas = document.getElementById("avatarCanvas"),
    context = canvas.getContext("2d"),
    width = canvas.width,
    height = canvas.height;
  var backgroundImage = new Image(100, 100);
  //操作區預覽底圖
  backgroundImage.onload = function () {
    context.drawImage(backgroundImage, 69, 50);
    console.log(backgroundImage);
  };
  backgroundImage.src = img;

  //實際預覽圖
  var previewImg = document.getElementById("avatarEditor-preview-img");

  //選擇區最大範圍
  var rectMaxSize = 500;
  //四個角落按鈕大小
  var controllerSize = 8;
  //按鈕跟rect大小比例
  var controllerSizeRatio = controllerSize / width;
  //扣除按鈕的rect大小
  var rectSize = rectMaxSize * (1 - controllerSizeRatio);

  //四個角落
  var points = [
    { x: 0, y: 1 },
    { x: 0, y: 0 },
    { x: 1, y: 0 },
    { x: 1, y: 1 },
  ];

  //控制大小?
  var is_gragging_resize_controller = false;
  //控制位置?
  var is_gragging_reposisiton_controller = false;

  //右下控制器
  var sizeController = document.getElementById("sizeController");
  sizeController.onmousedown = function (e) {
    e.preventDefault();
    is_gragging_resize_controller = true;
  };
  //位置控制器
  var positionController = document.getElementById("positionController");
  positionController.onmousedown = function (e) {
    e.preventDefault();
    is_gragging_reposisiton_controller = true;
    previous_mouse_pos = getMousePos(canvas, e);
  };
  //位置控制器--原本mouse位置
  var previous_mouse_pos = { x: 0, y: 0 };

  update();
  function update() {
    renderPoints();
    renderSticks();
    updatePreviewImg();
    requestAnimationFrame(update);
  }

  function renderPoints() {
    context.clearRect(0, 0, width, height);
    for (var i = 0; i < points.length - 1; i++) {
      var p = points[i];
      context.fillStyle = "#464646";
      context.beginPath();
      context.rect(
        p.x * rectSize,
        p.y * rectSize,
        controllerSize,
        controllerSize
      );
      context.fill();
    }
  }

  function renderSticks() {
    for (var i = 0; i < points.length; i++) {
      var p1 = points[i];
      var p2 = points[(i + 1) % points.length];
      context.beginPath();
      context.strokeStyle = "black";
      context.lineWidth = 1;
      context.moveTo(p1.x * rectMaxSize, p1.y * rectMaxSize);
      context.lineTo(p2.x * rectMaxSize, p2.y * rectMaxSize);
      context.stroke();
    }
  }

  function getMousePos(canvas, evt) {
    var rect = canvas.getBoundingClientRect();
    return {
      x: evt.clientX - rect.left,
      y: evt.clientY - rect.top,
    };
  }

  function updatePreviewImg() {
    var previewWidthRatio = 1 / (points[3].x - points[1].x); //x介於0~1
    previewImg.style.width = previewWidthRatio * 100 + "%";
    previewImg.style.height = previewWidthRatio * 100 + "%";
    previewImg.style.left = -points[0].x * previewWidthRatio * 100 + "%";
    previewImg.style.top = -points[1].y * previewWidthRatio * 100 + "%";

    previewResult = previewImg;
  }

  document.body.addEventListener("mouseup", function (event) {
    //重設所有bool
    is_gragging_resize_controller = false;
    is_gragging_reposisiton_controller = false;
  });

  document.body.addEventListener("mousemove", function (event) {
    //改變size
    if (is_gragging_resize_controller) {
      const rect = canvas.getBoundingClientRect();
      var mousePos = getMousePos(canvas, event);
      //保持正方形，所以只用width就行
      var newWidth = Math.abs(mousePos.x / rect.width - points[1].x) * rectSize;
      //p1的對角位置 =p3
      var newDiagonalPos = {
        x: points[1].x * rectSize + newWidth,
        y: points[1].y * rectSize + newWidth,
      };
      sizeController.style.right =
        (1 - controllerSizeRatio - newDiagonalPos.x / rectSize) * 100 + "%";
      sizeController.style.bottom =
        (1 - controllerSizeRatio - newDiagonalPos.y / rectSize) * 100 + "%";

      //修改其他點位置:
      points[3].x = newDiagonalPos.x / rectSize;
      points[3].y = newDiagonalPos.y / rectSize;

      points[0].y = newDiagonalPos.y / rectSize;
      points[2].x = newDiagonalPos.x / rectSize;

      //修改選擇範圍
      positionController.style.height = (points[0].y - points[1].y) * 100 + "%";
      positionController.style.width = (points[2].x - points[0].x) * 100 + "%";

      positionController.style.top = points[1].y * 100 + "%";
      positionController.style.left = points[0].x * 100 + "%";
    }

    //移動選取位置
    else if (is_gragging_reposisiton_controller) {
      var mousePos = getMousePos(canvas, event);
      //offset轉成%數
      var offsetX = (mousePos.x - previous_mouse_pos.x) / rectMaxSize;
      var offsetY = (mousePos.y - previous_mouse_pos.y) / rectMaxSize;

      //移動每個points
      for (var i = 0; i < points.length; i++) {
        var p = points[i];
        p.x += offsetX;
        p.y += offsetY;
        points[i] = p;
      }
      //移動resize按鈕
      sizeController.style.right =
        (1 - points[3].x - controllerSizeRatio) * 100 + "%";
      sizeController.style.bottom =
        (1 - points[3].y - controllerSizeRatio) * 100 + "%";

      //移動inner範圍
      positionController.style.top = points[1].y * 100 + "%";
      positionController.style.left = points[0].x * 100 + "%";

      previous_mouse_pos = mousePos;
    }
  });

  return points;
};

class AvatarEditor extends React.Component {
  state = {
    points: null,
  };
  constructor(props) {
    super(props);
    this.state = this.props;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleURLChange = this.handleURLChange.bind(this);
  }
  componentDidMount() {
    var points = openEditor(this.state.img);
    this.setState({ points: points });
  }

  handleSubmit(e) {
    //用點的位子計算縮放比例:
    var scale =
      (1 / (this.state.points[3].x - this.state.points[1].x)) * 100 + "%";

    var data = {
      //e: e,
      scale: scale,
      src: this.state.img,
      width: e.width,
      height: e.height,
      top: e.style.top,
      left: e.style.left,
    };
    this.state.onsubmit(data);
  }
  handleURLChange(e) {
    this.setState({ img: e.target.value });
  }

  render() {
    return (
      <>
        <div className="ui segment avatarEditor-root-container">
          {/* 退出按鈕 X */}
          <div className="avatarEditor-xButton" 
            onClick={(e) => {
              this.state.oncancel(e);
            }}>
            <Icon name="x" size="large"></Icon>
          </div>
          {/* 輸入網址 */}
          <div className="ui labeled input avatarEditor-input">
            <div className="ui label">url</div>
            <input
              type="url"
              label="url"
              value={this.state.img}
              placeholder="https://..."
              onChange={(e) => {
                this.handleURLChange(e);
              }}
            />
          </div>
          {/* 主要內容 */}
          <div className="avatarEditor-canvas-set-container">
            {/* 畫布 */}
            <div className="avatarEditor-canvas-root">
              <canvas
                id="avatarCanvas"
                width="500"
                height="500"
                className="avatarEditor-canvas"
              ></canvas>

              {/* 畫布底圖 */}
              <img id="canvas-img" src={this.state.img} />

              {/* 畫布右下控制按鈕 */}
              <button
                id="sizeController"
                className="avatarEditor-controller"
                onClick={(e) => {
                  e.preventDefault();
                }}
              ></button>

              {/* 畫布中間控制按鈕 */}
              <button
                id="positionController"
                className="avatarEditor-pos-controller"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                preview
              </button>
            </div>

            {/* 預覽 */}
            <div
              className="avatarEditor-preview-container"
              id="preview"
              style={{
                height: this.state.previewSize,
                width: this.state.previewSize,
              }}
            >
              <img src={this.state.img} id="avatarEditor-preview-img"></img>
            </div>
          </div>
          <div
            className="ui button avatarEditor-comfirm-button"
            onClick={() => {
              this.handleSubmit(previewResult);
            }}
          >
            確認
          </div>
        </div>
      </>
    );
  }
}

AvatarEditor.defaultProps = {
  img: "https://react.semantic-ui.com/images/wireframe/image.png",
  scale: 100,
  width: 100,
  height: 100,
  top: 0,
  left: 0,
  //preview大小
  previewSize: 300,
  onsubmit: (e) => {
    console.log("submit");
  },
  oncancel:(e)=>{
    //取消
  }
};
export default AvatarEditor;
